export default __webpack_public_path__ + "static/media/meh_icon.cceedafb.svg";